import React from 'react';
import { Card, List, Tag, Progress, Button, Typography, Space } from 'antd';
import { ProjectOutlined, CalendarOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import axios from 'axios';
import dayjs from 'dayjs';
import { useAuthStore } from '../../../stores/authStore';

const { Text } = Typography;

/**
 * 最近项目组件 - 只显示与当前用户有任务关联的项目
 */
const RecentProjects = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  // 获取与当前用户有任务关联的项目
  const { data: projectsData, isLoading, refetch, isFetching } = useQuery(
    ['recentProjects', user?.id],
    () => axios.get('/projects', { 
      params: { 
        limit: 5, 
        page: 1,
        hasUserTasks: true // 只获取当前用户有任务的项目
      } 
    }).then(res => res.data.data),
    { 
      refetchInterval: 60000,
      enabled: !!user?.id
    }
  );



  const getTypeText = (type) => {
    const typeTexts = {
      bidding: '投标',
      application: '申报',
      deepening: '深化',
      consultation: '咨询',
      other: '其他'
    };
    return typeTexts[type] || type;
  };

  const isOverdue = (expectedDate) => {
    return dayjs().isAfter(dayjs(expectedDate));
  };

  return (
    <Card 
      title={
        <Space>
          <ProjectOutlined />
          最近项目
        </Space>
      }
      extra={
        <Space>
          <Button 
            type="link"
            onClick={() => refetch()}
            loading={isFetching}
          >
            刷新
          </Button>
          <Button 
            type="link" 
            onClick={() => navigate('/projects')}
          >
            查看全部
          </Button>
        </Space>
      }
      className="status-card"
    >
      <List
        loading={isLoading}
        dataSource={projectsData?.projects || []}
        renderItem={(project) => (
          <List.Item
            style={{ 
              cursor: 'pointer',
              padding: '16px 0',
              borderBottom: '1px solid #f0f0f0'
            }}
            onClick={() => navigate(`/projects/${project.id}`)}
          >
            <List.Item.Meta
              title={
                <Space>
                  <Text strong>{project.name}</Text>
                  <Tag>{getTypeText(project.type)}</Tag>
                  {isOverdue(project.expectedDeliveryDate) && (
                    <Tag color="red">已逾期</Tag>
                  )}
                </Space>
              }
              description={
                <Space direction="vertical" size="small" style={{ width: '100%' }}>
                  <Text type="secondary" ellipsis>
                    {project.description || '暂无描述'}
                  </Text>
                  <Space>
                    <CalendarOutlined />
                    <Text type="secondary">
                      预期交付: {dayjs(project.expectedDeliveryDate).format('YYYY-MM-DD')}
                    </Text>
                  </Space>
                  <div style={{ marginTop: '8px' }}>
                    <Text type="secondary" style={{ marginBottom: '4px', display: 'block' }}>
                      项目进度
                    </Text>
                    <Progress 
                      percent={project.progress} 
                      size="small"
                      status={project.progress === 100 ? 'success' : 'active'}
                    />
                  </div>
                </Space>
              }
            />
          </List.Item>
        )}
        locale={{ emptyText: '暂无项目数据' }}
      />
    </Card>
  );
};

export default RecentProjects;
